import apiClient from '../axios/axios-instance';
import { BonusAction } from './bonus-action.interface';

export const bonusActionApi = {
  /**
   * Gets all available bonus actions for the current user
   */
  async getAvailableBonusActions(): Promise<BonusAction[]> {
    const response = await apiClient.get('/bonus-action');
    return response.data;
  },

  /**
   * Completes a bonus action for the current user
   */
  async completeBonusAction(actionType: number): Promise<BonusAction> {
    const response = await apiClient.post('/bonus-action/complete', {
      actionType,
    });
    return response.data;
  },
};
